<template>
  <div :class="getCss('rank-container')" :style="styles.base">
    <div class="s-con" :style="styles.bgColorStyle">
      <div class="s-top" v-if="configurationData.showWeekDateItem">
        <div class="w-top-inner">
          <div v-for="(item,index) in weekListRecord"
            :key="index"
            @click="switchWeek(index)"
            :class="{
              'items': index !== weekActiveIndex,
              'items active' : index === weekActiveIndex
              }"
            :style="weekFontStyle(index)"
            >
            <p>
              <span>{{item.title}}</span>
              <span>{{item.beginDate}}-{{item.endDate}}</span>
            </p>
            <span :class="{
              'first-span-ele':index !== weekListRecord.length -1,
              'last-span-ele':index === weekListRecord.length -1,
            }"></span>
          </div>
        </div>
      </div>
      <div class="m-center">
        <div v-for="(item,itemIndex) in recordList"
          :key="itemIndex"
          :class="{
              'items': item.rank !== myRankInfo.rank,
              'items active' : item.rank === myRankInfo.rank
              }">
          <div class="left">
            <span>{{ item.rank ||  itemIndex +1 }}</span>
            <div>
              <img
                :src="item.avatar || defaultHeadImg"
              />
              <p>
                <span>{{ item.nickname || '虚位以待'}}</span>
                <span>
                  <i>{{ item.rank_level_text || '当前段位'}}</i>
                  <em v-if="!!item.area_id"></em>
                  <i>{{item.area_id ? areaContent(item.area_id) : ''}}</i>
                </span>
              </p>
            </div>
          </div>
          <span>{{item.total_score || '--'}}分</span>
        </div>
      </div>
      <div class="s-bottom">
        <div class="items">
          <div class="left">
            <span v-if="myRankInfo.game_openid"><i>我的排名</i>{{myRankInfo.rank  || '1000+' }}</span>
            <span v-else><i>我的排名</i>--</span>
            <div>
              <img
                :src="myRankInfo.avatar || defaultHeadImg"
              />
              <p>
                <span v-if="myRankInfo.game_openid">{{   myRankInfo.nickname || '昵称' }}</span>
                <span v-else>虚位以待</span>
                <span v-if="myRankInfo.game_openid">
                  <i>{{myRankInfo.rank_level_text || '段位'}}</i>
                  <em></em>
                  <i>{{myRankInfo.area_id ? areaContent(myRankInfo.area_id) : ''}}</i>
                </span>
                <span v-else>当前段位</span>
              </p>
            </div>
          </div>
          <span v-if="myRankInfo.game_openid">{{   myRankInfo.total_score || 0 }}分</span>
          <span v-else>--分</span>
        </div>
      </div>
    </div>
  </div >
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import {  componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CTgclubCompetitionRankNewVersion',
  components: {
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-match-rank-new-version',
      weekActiveIndex: 0,
      record: [],
      page: 0,
      total: 0,
      noDataListStatus: false,
      myRankInfo: {},
    };
  },
  computed: {

    weekFontStyle() {
      return (index) => {
        if (index === this.weekActiveIndex) {
          return { color: this.styles.weekFontStyle.activeColor };
        }
        return { color: this.styles.weekFontStyle.color };
      };
    },

    recordList() {
      if (this.$isInEditor) {
        const temp =  new Array(this.pageSize).fill({ available: false })
          .map((item, index) => ({
            available: false,
            rank: index + 1,
          }));
        console.log('temp-------------', temp);
        return  temp;
      }
      const list = this.record.map(item => ({
        rank: item.rank,
        total_score: item.total_score,
        ...item.player,
      }));
      console.log('recordList = ', list);
      if (list.length < 5) { // 如果列表排名数据少于5,填充剩下的,页面上依然展示前五名
        const addLength = 5 - list.length;
        for (let index = 0; index < addLength; index++) {
          list.push({
            available: false,
            rank: list.length + 1,
          });
        }
      }
      return  list;
    },
    weekListRecord() {
      const { weekList = [] } =  this.configurationData;
      const getTime = function (time) {
        if (!time) return  '';
        // eslint-disable-next-line no-param-reassign
        time = time.replace(/-/g, '/');
        const m = new Date(time).getMonth() + 1;
        const day = new Date(time).getDate();
        return  `${m < 10 ? `0${m.toString()}` : m}.${day < 10 ? `0${day.toString()}` : day}`;
      };
      return weekList.map((item) => {
        const beginDate = getTime(item.beginTime);
        const endDate = getTime(item.endTime);
        return {
          title: item.title,
          beginDate,
          endDate,
        };
      });
    },
    defaultHeadImg() {
      return this.configurationData.defaultHeadImg;
    },

    pageSize() {
      return this.configurationData.pageSize || 5;
    },

  },
  watch: {
    weekActiveIndex: {
      handler(newVal) {
        if (!this.configurationData.showWeekDateItem) return;
        if (this.$isInEditor) return;
        // 避免进入页面 请求多一次
        if (!this.hasAccess) {
          return;
        }
        this.page  = 1 ;
        console.log('getRankList on watch weekActiveIndex', newVal);
        // 向完整榜单按钮传递周信息
        this.$eventBus.$emit('ceiba:custom:events:competition-rank-week', {
          weekInfo: this.weekListRecord[newVal] || {},
          weekActiveIndex: this.weekActiveIndex,
        });
        this.getRankList(1, newVal);
      },
      immediate: true,
    },
    roleInfo: {
      async handler(newVal) {
        if (this.$isInEditor) return;

        console.log('watch  roleInfo', newVal);
        const { role_id: roleId = '' } = newVal || {};
        if (this.page  === 0) this.page = 1;
        if (this.isSleeping) {
          return false;
        }
        // 向完整榜单按钮传递周信息
        console.log('this.$eventBus.$emit', this.weekListRecord);
        this.$eventBus.$emit('ceiba:custom:events:competition-rank-week', {
          weekInfo: this.weekListRecord[this.weekActiveIndex],
          weekActiveIndex: this.weekActiveIndex,
        });
        if (roleId) {
          this.isSleeping = true;
          await this.doSleep(2000);
          this.getRankList(this.page, this.weekActiveIndex);
          this.isSleeping = false;
        }
      },
      immediate: true,
    },

  },
  mounted() {
    console.log(' version 1.0.0 排行榜 tgclub-user-rank configurationData=', this.configurationData);
    console.log(' version 1.0.0 排行榜 tgclub-user-rank styles=', this.styles);
    this.$eventBus.$emit('ceiba:custom:events:competition-rank-week', {
      weekInfo: this.weekListRecord[0] || {},
      weekActiveIndex: 0,
    });
    this.initialize();
  },
  methods: {
    switchWeek(index) {
      this.weekActiveIndex = index;
      this.reportFunc('switch_tab', { tab_id: `${index}` });
    },
    areaContent(areaId) {
      const obj =  {
        1: '微信区',
        2: 'QQ区',
        3: '游客',
      };
      return obj[areaId] ? obj[areaId] : '未知';
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    initialize() {
      if (this.$isInEditor) return;
      this.$onLogined(() => {
        this.page = 1;
        this.getRankList(this.page, this.weekActiveIndex);
      });
    },
    async getRankList(page, index) {
      this.hasAccess = true;
      const { getRankListFlowId } = this.configurationData;
      const { game_open_id: gameOpenId = '', role_id: roleId } = this.roleInfo;
      if (getRankListFlowId <= 0) return;
      const params = {
        flowId: getRankListFlowId,
        params: {
          data: JSON.stringify({ week: index + 1,
            page_number: page,
            page_size: this.pageSize,
            game_open_id: gameOpenId,
            game_roleid: roleId,
          }),
          role: this.roleInfo,
        },
      };
      console.log('getRankList request', params);
      const response = await this.flowRequest(params);
      console.log('getRankList response', response);
      const { msg, ret, data } = response;
      if (ret !== 0 || !data) {
        this.$alert({ msg: msg || '获取榜单失败' });
        return false;
      }
      const { ret: resRet, err, data: resData  } = data;
      if (resRet !== 0) {
        this.$alert({ msg: err || '获取榜单失败' });
        return false;
      }
      // eslint-disable-next-line prefer-const
      let { list = '[]', myself = '{}', total_page: totalPage = 0 } = resData || {};
      console.log('getRankList response', resData);

      list = list ?  JSON.parse(list) : [];
      myself = myself ? JSON.parse(myself) : {};
      if (list.length === 0) {
        // 没有榜单
        this.myRankInfo = {};
        this.total = 0;
        this.noDataListStatus = true;
        this.record = [];
        return;
      }
      this.record = list;
      this.total = totalPage;
      this.noDataListStatus = false;
      console.log('myRankInfo 榜单',  myself);
      this.myRankInfo = { rank: myself.rank, total_score: myself.total_score, ...myself?.player ?? {} };
      console.log('myRankInfo 榜单',  this.myRankInfo);
    },


    reportFunc(key, eventData) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key} data =`, params);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
